import { useState } from 'react';

export function useConfirmDialog() {
  const [dialog, setDialog] = useState({
    open: false,
    type: 'warning',
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'Confirm',
    cancelText: 'Cancel'
  });

  const confirm = ({ type = 'warning', title, message, onConfirm, confirmText, cancelText }) => {
    return new Promise((resolve) => {
      setDialog({
        open: true,
        type,
        title,
        message,
        confirmText: confirmText || 'Confirm',
        cancelText: cancelText || 'Cancel',
        onConfirm: async () => {
          setDialog(prev => ({ ...prev, open: false }));
          if (onConfirm) await onConfirm();
          resolve(true);
        }
      });
    });
  };

  const close = () => {
    setDialog(prev => ({ ...prev, open: false }));
  };

  return { dialog, confirm, close };
}

export function useAlertDialog() {
  const [dialog, setDialog] = useState({
    open: false,
    type: 'info',
    title: '',
    message: '',
    buttonText: 'OK'
  });

  const alert = ({ type = 'info', title, message, buttonText }) => {
    setDialog({
      open: true,
      type,
      title,
      message,
      buttonText: buttonText || 'OK'
    });
  };

  const close = () => {
    setDialog(prev => ({ ...prev, open: false }));
  };

  return { dialog, alert, close };
}
